// extracted by mini-css-extract-plugin
export default {"errorMessage":"ErrorChip_errorMessage__wxcYh","errorIcon":"ErrorChip_errorIcon__ndF1s"};